import { render, staticRenderFns } from "./promotion-url-textbox.component.vue?vue&type=template&id=85d323fe"
import script from "./promotion-url-textbox.component.vue?vue&type=script&lang=ts"
export * from "./promotion-url-textbox.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports